import { render, staticRenderFns } from "./VueDatatable.vue?vue&type=template&id=7b0e6cbd"
import script from "./VueDatatable.vue?vue&type=script&lang=js"
export * from "./VueDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports